import React from 'react';
import { observer, inject } from 'mobx-react';
import WeaSystemField from '../../public/wf-system-field/index';
import SecLevelField from './SecLevelField';
import * as FieldUtil from '../../util/public/fieldUtil';

@inject('globalStore', 'layoutStore')
@observer
export default class SystemElement extends React.Component{
    doChangeEvent = (value) => {
        const { globalStore,layoutStore,fieldMark, baseProps } = this.props;
        const {value:fieldValue} = baseProps;
        layoutStore.changeSingleFieldValue(fieldMark, {value: value});
	}
    render() {
        const { globalStore,layoutStore,fieldMark,fieldObj } = this.props;
        let { baseProps } = this.props;
        if(baseProps.fieldid == "-10")  //密级字段
            return <SecLevelField viewAttr={baseProps.viewAttr} />;
        const { commonParam,markInfo } = globalStore;
        const {containSignInput, propFileCfg} = layoutStore;
        const { closeAutoComplete = '0', autocomplete_change_name = '0' } = propFileCfg;
        const { requestType } = commonParam;
        baseProps.fieldName  = FieldUtil.convertSystemFieldName(fieldMark);
        baseProps.specialobj = fieldObj.specialobj || [];
        baseProps.closeAutoComplete = closeAutoComplete;
        baseProps.autocomplete_change_name = autocomplete_change_name;
		//扩展组件参数
		const { variable } = fieldObj;
		if(baseProps.viewAttr !== 1){   //文本类型字段空值显示的默认值
			baseProps.emptyShowContent = variable.get("emptyShowContent") || "";
		}
        return (
            <WeaSystemField ecId={`${this && this.props && this.props.ecId || ''}_WeaSystemField@tuxsa6`} 
                requestType={requestType}
                markInfo={markInfo}
                containSignInput = {containSignInput}
                onChange={this.doChangeEvent}
                {...baseProps}
            />
        )
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/workflowForm/components/fieldType/SystemElement.js